import { render, staticRenderFns } from "./desktopdeliverylist.vue?vue&type=template&id=40514537&"
import script from "./desktopdeliverylist.vue?vue&type=script&lang=js&"
export * from "./desktopdeliverylist.vue?vue&type=script&lang=js&"
import style0 from "./desktopdeliverylist.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports